module.exports = __webpack_public_path__ + "img/person-check-fill.9e1b5b9a.svg";